import { render, staticRenderFns } from "./interestGroup.vue?vue&type=template&id=cbff97c8&scoped=true"
import script from "./interestGroup.vue?vue&type=script&lang=js"
export * from "./interestGroup.vue?vue&type=script&lang=js"
import style0 from "./interestGroup.vue?vue&type=style&index=0&id=cbff97c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbff97c8",
  null
  
)

export default component.exports